import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CustomOrderEntry } from '@cart/const';

@Component({
  selector: 'sd-cart-list-item-price',
  standalone: true,
  templateUrl: './cart-list-item-price.component.html',
  styleUrls: ['./cart-list-item-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartListItemPriceComponent {
  protected readonly entry = input.required<CustomOrderEntry>();

  protected readonly isRent = computed(() => this.entry().product?.isRent ?? false);

  protected readonly totalPrice = computed(() => this.entry().totalPrice?.formattedValue ?? '');

  protected readonly unitPrice = computed(() => {
    const { personalPrice, basePrice, saleUnit } = this.entry();
    const price = personalPrice?.formattedValue ?? basePrice?.formattedValue ?? '';
    const unit = saleUnit?.name ?? '';

    return unit ? `${price}/${unit}` : price;
  });
}
